import styled from 'styled-components';
import P from './P';

const B = styled(P)`
  font-weight: bold;
`;

export default B;
